import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useToast } from 'primevue/usetoast';
import type { User } from './type';
import { UserRepository } from './repository';
import router from '@/router';
import * as Sentry from "@sentry/vue";

export const useUsers = defineStore('users', () => {

    const toast = useToast();
    const userRepository = new UserRepository();
    const loggedUser = ref<User | null>(null)
    const userToken = ref<string | null>(null)
    const userAbility = ref<string | null>(null)

    const login = async (credentials: { email: string, password: string }) => {
        const res = await userRepository.login(credentials)
        if (res.error) {
            toast.add({ severity: 'error', summary: 'Une erreur s\'est produite', detail: res.data?.message, life: 3000 });
        } else if (res.data?.data?.user) {
            loggedUser.value = res.data.data.user
            if (res.data?.data?.token) {
                userToken.value = res.data.data.token
            }
        }
        return res
    }

    const loginWithToken = async (token: string) => {
        let res = await userRepository.connectModule(token)
        if (!res.data.error) {
            if (res.data?.ability) {
                loggedUser.value = res.data.employee
                userToken.value = token
                Sentry.setUser({ id: loggedUser.value?.id, email: loggedUser.value?.email, username: loggedUser.value?.first_name + ' ' + loggedUser.value?.last_name });
                userAbility.value = res.data.ability
                if (res.data.ability === 'veterinary') {
                    router.push({ name: 'veterinary' })
                    return
                }
                else if (res.data.ability === 'watcher') {
                    router.push({ name: 'watcher' })
                    return
                }
                else if (res.data.ability === 'farrier') {
                    router.push({ name: 'farrier' })
                    return
                }
                else if (res.data.ability === 'medical') {
                    router.push({ name: 'medical' })
                    return
                }
                else if (res.data.ability === 'ticketing') {
                    router.push({ name: 'ticketing' })
                    return
                }
            }
            toast.add({ severity: 'error', summary: 'Code non valide', detail: res.data?.message, life: 3000 });
            router.push({ name: 'login' })
        } else {
            toast.add({ severity: 'error', summary: 'Une erreur s\'est produite', detail: res.data?.message, life: 3000 });
        }
    }

    const setTokenFromUrl = (token: string) => {
        userToken.value = token
    }

    const logout = async () => {
        // const res = await userRepository.logout();
        // if (!res.error) {
        loggedUser.value = null;
        userToken.value = null;
        userAbility.value = null;
        router.push({ name: 'login' });
        // } else {
        // toast.add({ severity: 'error', summary: 'Une erreur s\'est produite', detail: res.data?.message, life: 3000 });
        // }
    }

    const getUser = async () => {
        const res = await userRepository.getUser()
        loggedUser.value = res.data.user
        return res
    }

    return {
        loggedUser,
        userToken,
        userAbility,
        login,
        loginWithToken,
        setTokenFromUrl,
        logout,
        getUser,
    }

}, {
    persist: {
        paths: ['loggedUser', 'userToken', 'userAbility'],
    },
})